//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'aiQuery',
  data () {
    return {
      status: {enabled:0,points_balance:0,suggestions:[],store:{}},
      question:'', loading:false, historyLoading:false, history:[], historyScope:'active', archivingKey:'', selectedHistory:null, historyOpen:false,
      promptOpen:false, promptSearch:'', promptUsage:{}, progressTimers:[],
      conversationId:'', conversationEntries:[]
    }
  },
  computed:{
    hasConversation(){ return this.conversationEntries.length > 0 },
    conversationHistory(){
      const groups = {}
      this.history.forEach(item=>{
        const conversationId = String(item.conversation_id || '').trim()
        const key = conversationId || ('legacy-' + item.id)
        if(!groups[key]) groups[key] = []
        groups[key].push(item)
      })
      return Object.keys(groups).map(key=>{
        const items = groups[key].slice().sort((a,b)=>Number(a.id || 0) - Number(b.id || 0))
        const root = Object.assign({},items[0])
        const latest = items[items.length - 1]
        root.status = latest.status
        root.create_time_text = latest.create_time_text
        root.points = items.reduce((total,item)=>total + Number(item.points || 0),0)
        root.latest_id = Number(latest.id || 0)
        return root
      }).sort((a,b)=>b.latest_id - a.latest_id)
    },
    allSuggestions(){
      const seen = {}
      return (this.status.suggestions || []).map(item=>String(item || '').trim()).filter(item=>item && !seen[item] && (seen[item] = true))
    },
    frequentSuggestions(){
      const usage = this.history.reduce((result,item)=>{ const value=String(item.question || '').trim(); if(value) result[value]=(result[value] || 0)+1; return result },{})
      return this.allSuggestions.map((item,index)=>({item:item,index:index,score:(Number(this.promptUsage[item]) || 0)*10+(usage[item] || 0)}))
        .sort((a,b)=>b.score-a.score || a.index-b.index).slice(0,4).map(item=>item.item)
    },
    filteredSuggestions(){ const keyword=this.promptSearch.trim().toLowerCase(); return this.allSuggestions.filter(item=>!keyword || item.toLowerCase().indexOf(keyword)>-1) }
  },
  created(){
    if(!this.$func.checkAuth('aiQuery')){ this.$func.showToast('暂无访问权限'); this.$router.replace({path:'/'}); return }
    this.conversationId = this.createConversationId()
    this.loadStatus()
    this.loadHistory()
  },
  beforeDestroy(){ this.clearTimers() },
  methods:{
    loadStatus(){ return this.$api.aiQueryStatus({}).then(res=>{ if(res && res.data){ this.status=res.data; this.loadPromptUsage() } }) },
    loadHistory(){
      const scope=this.historyScope
      const archived=scope==='archived'?1:0
      this.historyLoading=true
      return this.$api.aiQueryHistory({archived:archived,_t:Date.now()}).then(res=>{
        if(this.historyScope===scope && res && Array.isArray(res.data)) this.history=res.data.filter(item=>Number(item.archived || 0)===archived)
      }).then(()=>{ this.historyLoading=false },()=>{ this.historyLoading=false })
    },
    switchHistoryScope(scope){
      if((scope!=='active' && scope!=='archived') || this.historyScope===scope) return
      this.historyScope=scope; this.history=[]; this.loadHistory()
    },
    historyItemKey(item){ return String(item.conversation_id || ('legacy-' + item.id)) },
    isHistoryActive(item){
      const itemConversation=String(item.conversation_id || '')
      if(itemConversation) return itemConversation===String(this.conversationId || '') && this.conversationEntries.length>0
      return !!this.selectedHistory && String(this.selectedHistory.id)===String(item.id)
    },
    archiveHistory(item){
      if(this.archivingKey) return
      const key=this.historyItemKey(item),archived=this.historyScope==='archived'?0:1
      this.archivingKey=key
      this.$api.aiQueryArchive({conversation_id:item.conversation_id || '',query_id:item.id,archived:archived}).then(()=>{
        if(archived===1 && this.isHistoryActive(item)) this.newQuery()
        return this.loadHistory()
      }).then(()=>{ this.archivingKey='' },()=>{ this.archivingKey='' })
    },
    createConversationId(){
      if(window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID()
      return 'conversation-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,12)
    },
    freshSteps(){ return [{label:'理解查询需求',state:'pending'},{label:'生成查询计划',state:'pending'},{label:'查询门店数据',state:'pending'},{label:'生成结果文件',state:'pending'}] },
    stepsForStatus(status){
      const steps=this.freshSteps()
      if(status==='success') steps.forEach(step=>{ step.state='done' })
      else if(status==='failed'){ steps[0].state='done'; steps[1].state='failed' }
      else if(status==='parsing'){ steps[0].state='done'; steps[1].state='active' }
      else if(status==='executing'){ steps[0].state='done'; steps[1].state='done'; steps[2].state='active' }
      else if(status==='clarification_required' || status==='unsupported'){ steps[0].state='done'; steps[1].state='failed' }
      else steps[0].state='done'
      return steps
    },
    startProgress(entry){
      this.clearTimers(); entry.executionSteps=this.freshSteps(); entry.executionSteps[0].state='active'
      ;[700,1800,3500].forEach((delay,index)=>{ this.progressTimers.push(setTimeout(()=>{ if(!entry.loading) return; entry.executionSteps[index].state='done'; entry.executionSteps[index+1].state='active' },delay)) })
    },
    finishProgress(entry,success){
      this.clearTimers()
      if(success){ entry.executionSteps.forEach(step=>{ step.state='done' }); return }
      const active=entry.executionSteps.find(step=>step.state==='active'); if(active) active.state='failed'
    },
    clearTimers(){ this.progressTimers.forEach(timer=>clearTimeout(timer)); this.progressTimers=[] },
    stepStatusText(state){ return {done:'已完成',active:'执行中',failed:'执行失败',pending:'等待中'}[state] || '等待中' },
    executionText(entry){
      if(entry.loading) return '执行中'
      if(entry.requestFailed) return '失败'
      if(entry.status==='unsupported') return '不支持'
      if(entry.messageType==='warning') return '需要补充'
      return this.statusText(entry.status || (entry.result ? 'success' : ''))
    },
    canRetry(entry){ return !this.loading && !!this.status.enabled && !!entry.question && (entry.requestFailed || entry.status==='unsupported') },
    newQuery(){
      if(this.loading) return
      if(this.historyScope!=='active'){ this.historyScope='active'; this.loadHistory() }
      this.clearTimers(); this.question=''; this.selectedHistory=null; this.historyOpen=false; this.promptOpen=false
      this.conversationId=this.createConversationId(); this.conversationEntries=[]
      this.$nextTick(()=>{ if(this.$refs.queryInput) this.$refs.queryInput.focus() })
    },
    historyEntry(item){
      return {clientId:'history-'+item.id,id:item.id,conversationId:item.conversation_id || '',question:item.question,status:item.status,
        points:item.points,row_count:item.row_count,create_time_text:item.create_time_text,summary:item.summary,error_message:item.error_message,
        file_url:item.file_url,result:item.result || null,message:item.result?'':(item.summary || item.error_message || ''),
        suggestions:item.suggestions || [],
        messageType:item.status==='failed'?'warning':(item.status==='success'?'success':'info'),loading:item.status==='parsing' || item.status==='executing',
        requestFailed:item.status==='failed',fromHistory:true,executionSteps:this.stepsForStatus(item.status)}
    },
    selectHistory(item){
      this.selectedHistory=item; this.historyOpen=false
      if(!item.conversation_id){ this.conversationId=this.createConversationId(); this.conversationEntries=[this.historyEntry(item)]; this.scrollBottom(); return }
      this.conversationId=item.conversation_id
      this.$api.aiQueryHistory({conversation_id:item.conversation_id}).then(res=>{
        const rows=res && Array.isArray(res.data)?res.data:[item]
        this.conversationEntries=rows.map(row=>this.historyEntry(row)); this.scrollBottom()
      })
    },
    submit(questionOverride){
      const value=typeof questionOverride==='string'?questionOverride.trim():this.question.trim()
      if(this.loading || !value || !this.status.enabled) return
      if(this.historyScope!=='active') this.historyScope='active'
      if(!this.conversationId) this.conversationId=this.createConversationId()
      const entry={clientId:'pending-'+Date.now()+'-'+Math.random().toString(36).slice(2,8),id:0,conversationId:this.conversationId,
        question:value,status:'parsing',points:0,row_count:0,create_time_text:'',summary:'',error_message:'',file_url:'',result:null,
        suggestions:[],message:'',messageType:'info',loading:true,requestFailed:false,fromHistory:false,executionSteps:this.freshSteps()}
      this.conversationEntries.push(entry); this.loading=true; this.selectedHistory=null; this.question=''; this.startProgress(entry); this.scrollBottom()
      this.$api.aiQuery({question:value,conversation_id:this.conversationId}).then(res=>{
        if(res && Number(res.code)) throw new Error(res.msg || '查询失败，请稍后重试')
        if(!res || !res.data) throw new Error('未收到查询结果')
        const data=res.data; entry.id=data.query_id || 0; entry.conversationId=data.conversation_id || this.conversationId; this.conversationId=entry.conversationId; entry.status=data.status
        if(data.status==='clarification_required' || data.status==='unsupported'){
          entry.message=data.message || '当前需求需要补充信息'; entry.suggestions=data.suggestions || []; entry.messageType='warning'; entry.requestFailed=false; this.status.points_balance=data.points_balance; this.finishProgress(entry,false); return
        }
        entry.result=data; entry.points=data.points_used || 0; entry.row_count=data.row_count || 0; entry.file_url=data.file_url || ''
        entry.message='查询完成，本次消耗 '+(data.points_used || 0)+' 积分'; entry.messageType='success'; entry.requestFailed=false
        this.status.points_balance=data.points_balance; this.finishProgress(entry,true)
      }).catch(error=>{
        const isTimeout=error && (error.code==='ECONNABORTED' || error.code==='ETIMEDOUT' || /timeout/i.test(String(error.message || '')))
        entry.status=isTimeout?'executing':'failed'; entry.requestFailed=!isTimeout
        entry.message=isTimeout?'AI 查询处理时间较长，可能仍在后台执行，请稍后查看执行记录，勿重复提交':this.friendlyError(error && error.message)
        entry.messageType=isTimeout?'info':'warning'; this.finishProgress(entry,false)
      }).then(()=>{
        entry.loading=false; this.loading=false; this.loadStatus(); this.loadHistory(); this.scrollBottom()
      })
    },
    retry(entry){ if(this.canRetry(entry)) this.submit(entry.question) },
    useSuggestion(item){ this.recordPromptUsage(item); this.question=item; this.promptOpen=false; this.$nextTick(()=>{ if(this.$refs.queryInput) this.$refs.queryInput.focus() }) },
    promptUsageKey(){ return 'ai-query-prompt-usage:' + ((this.status.store && this.status.store.id) || 'default') },
    loadPromptUsage(){ try{ this.promptUsage=JSON.parse(localStorage.getItem(this.promptUsageKey()) || '{}') || {} }catch(e){ this.promptUsage={} } },
    recordPromptUsage(item){ const usage=Object.assign({},this.promptUsage); usage[item]=(Number(usage[item]) || 0)+1; this.promptUsage=usage; try{ localStorage.setItem(this.promptUsageKey(),JSON.stringify(usage)) }catch(e){} },
    scrollBottom(){ this.$nextTick(()=>{ if(this.$refs.content) this.$refs.content.scrollTop=this.$refs.content.scrollHeight }) },
    download(url){ if(url) window.open(url,'_blank') },
    friendlyError(message){
      const value=String(message || '')
      if(/cURL error 28|timed?\s*out|timeout/i.test(value)) return 'AI 服务响应超时，请点击重试'
      if(/cURL error (6|7)|could not resolve|failed to connect|connection refused/i.test(value)) return 'AI 服务暂时无法连接，请稍后重试'
      if(/cURL error|libcurl|https:\/\/curl\.haxx\.se/i.test(value)) return 'AI 服务调用失败，请稍后重试'
      return value || '查询失败，请稍后重试'
    },
    formatCount(value){ const number=Number(value); return isFinite(number)?number.toLocaleString('zh-CN'):'0' },
    statusText(status){ return {success:'成功',failed:'失败',parsing:'解析中',executing:'查询中',clarification_required:'待补充',unsupported:'不支持'}[status] || status }
  }
}



// WEBPACK FOOTER //
// ./src/pages/aiQuery.vue